// import React from 'react'

// const ViewGrnHistory = () => {
//   return (
//     <div>ViewGrnHistory</div>
//   )
// }

// export default ViewGrnHistory

import * as React from "react";
import { useState, useEffect, useContext } from "react";
import { AnyForNow, GrnData, GrnItem } from "./types";
import { useStyles } from "../../assets/styles/Theme";
import { Box, Typography, Button, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ViewDetailGrnBody from "../../components/grn/ViewDetailGrnBody";
import ReviewGrnAction from "../../components/grn/ReviewGrnAction";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { submitGrnData } from "../../services/GrnApi";
import SystemAlert from "../../components/common/SystemAlert";
import { externalgetApi, externalpostApi } from "../../services/externalApis";
import { CON_STATUS_ZERO, CON_BUSINESS_TYPECODE } from "../../utils/sys/Constants";
import { GRN_API_01, GRN_API_03, GRN_API_11 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import PopUp from "../../components/popup/PopUp";
import GrnAttachments from "../../components/grn/GrnAttachments";
import Grnresattachments from "../../components/grn/Grnresattachments";
import {
  GRN_ALERT_TYPE,
  GRN_CONSTRAINTS,
  GRN_DEFAULTS,
  GRN_GOODS_RETURN_STATUS,
  GRN_STATUS,
  GRN_STORAGE_KEYS,
  GRN_VIEW_DETAIL,
  GRN_VIEW_DETAIL_REASON_CATEGORY,
} from "../../utils/sys/GrnConstants";
import { BUTTON_LABELS, GRN_VIEW_DETAIL_LABELS } from "../../utils/sys/GrnLabels";
import { GRN_ROUTES, RELATED_ROUTES } from "../../utils/sys/GrnRoutes";
import {
  GRN_SUCCESS_MESSAGES,
  GRN_FAILURE_MESSAGES,
  GRN_ERROR_MESSAGES,
  GRN_CONFIRM_MESSAGES,
} from "../../utils/sys/GrnValidation";
import { useAlertQueue } from "../../hooks/useAlertQueue";
import ViewDetailGrn from "./ViewDetailGrn";

const GRN_STATUS_ACTION_MAP: Record<number, string> = {
  1: BUTTON_LABELS.APPROVE,
  2: BUTTON_LABELS.HOLD,
  3: BUTTON_LABELS.SUBMIT,
  4: BUTTON_LABELS.RETURN,
};

interface ViewDetailGrnProps {}

const ViewGrnHistory: React.FC<ViewDetailGrnProps> = ({}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  // Check for data in location.state first, then fall back to localStorage
  const locationState = location?.state || {};
  const persistedViewData = localStorage.getItem(GRN_STORAGE_KEYS.GRN_VIEW_DATA);
  const persistedData = persistedViewData ? JSON.parse(persistedViewData) : {};

  // Use location.state if available, otherwise use persisted data
  // But only use persisted data if it's recent (within last 2 hours to allow for navigation)
  const isPersistedDataRecent =
    persistedData.timestamp &&
    Date.now() - persistedData.timestamp < GRN_VIEW_DETAIL.PERSIST_WINDOW_MS;

  const viewData = Object.keys(locationState).length > 0 ? locationState :
    (isPersistedDataRecent ? persistedData : {});

  const {
    grncode,
     trsts,
    totalGross,
    taxValues,
    grnTaxTypes,
    totalDiscount,
  } = viewData;

  const moduleParamJson = useSelector((state: AnyForNow) => state.moduleParamJson);
  const PARAID = moduleParamJson && moduleParamJson[0]?.PARAID;
  const PARAVALUE = moduleParamJson && moduleParamJson[0]?.PARAVALUE;

  console.log("moduleParamJson", moduleParamJson);
  console.log("PARAID", PARAID);
  console.log("PARAVALUE", PARAVALUE);

  const { alertState, showAlert, handleClose: handleAlertClose } = useAlertQueue();
  const { open: alertOpen, type: alertType, message: alertMessage } = alertState;
  const [remark, setRemark] = useState<string>(GRN_DEFAULTS.STRING);
  const [reason, setReason] = useState<string>(GRN_DEFAULTS.STRING);
  const [reasonCode, setReasonCode] = useState<string>(GRN_DEFAULTS.STRING); // code
  const [selectedReasonCatCode, setSelectedReasonCatCode] =
    useState<string>(GRN_DEFAULTS.STRING);
  const [reasonError, setReasonError] = useState<string>("");
const [otherchargevalue, setotherchargevalue] = useState<AnyForNow[]>([]);
  const [confirmHoldOpen, setConfirmHoldOpen] = useState<boolean>(false);
  const statusCode = viewData?.trsts;
  const normalizedStatusCode =
    statusCode === undefined || statusCode === null
      ? GRN_DEFAULTS.STRING
      : String(statusCode);
  const origin = viewData?.origin;
  const holdLikeStatuses = GRN_VIEW_DETAIL.HOLD_LIKE_STATUSES as readonly string[];
  const approverHiddenStatuses =
    GRN_VIEW_DETAIL.APPROVER_HIDE_STATUSES as readonly string[];
  const returnApprovalStatuses =
    GRN_VIEW_DETAIL.RETURN_APPROVAL_STATUSES as readonly string[];
  const {
    grnItems = [],
    selectedSupplier = [],
    grnDetailsForm,
    grnData = [],
    attachments = [], // Define attachments here
   addedCharges = [],
     processResponse,
     calSummary,
     grncal
    // charges = [],
  } = viewData;
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { COMPCODE, USERNAME, STAFFMAPLOCODE } = SYS_USER.USER_PARAM || {};
const [resattachments, setresAttachments] = useState<AnyForNow[]>([]);
  const [grnList, setGrnList] = useState<AnyForNow[]>([]);
  const [trackingDetails, setTrackingDetails] = useState<AnyForNow[]>([]);
  const [grnDocuments, setGrnDocuments] = useState<AnyForNow[]>([]);
  const [grnReturns, setGrnReturns] = useState<AnyForNow[]>([]);
  const [grnPaySummery, setGrPaySummery] = useState<AnyForNow[]>([]);
  const [grnPayTax, setGrnPayTax] = useState<AnyForNow[]>([]);
   const [grnReturnList, setgrnReturnList] = useState<AnyForNow[]>([]);
  const [grnReturnMaster, setGrnReturnMaster] = useState<AnyForNow[]>([]);
  const [grnCompany, setGrnCompany] = useState<AnyForNow[]>([]);
  const [grncharges, setGrnCharges] = useState<AnyForNow[]>([]);
  const [grnRejectList, setGrnRejectList] = useState<AnyForNow[]>([]);

  const goToBack = (): void => {
    if (origin === GRN_VIEW_DETAIL.ORIGIN_CREATE) {
      navigate(GRN_ROUTES.CREATE);
    } else if (origin === GRN_VIEW_DETAIL.ORIGIN_APPROVER) {
      if (returnApprovalStatuses.includes(normalizedStatusCode)) {
        navigate(GRN_ROUTES.VIEW_HOOD_RETURN_APPROVAL);
      } else {
        navigate(GRN_ROUTES.VIEW_APPROVER);
      }
    } else if (origin === GRN_VIEW_DETAIL.ORIGIN_EDIT) {
      // Get pocode from grnList header if available
      const pocode = grnList.length > 0 && grnList[0]?.header?.pocode 
        ? grnList[0].header.pocode 
        : viewData?.pocode || undefined;
      navigate(GRN_ROUTES.EDIT, { 
        state: { 
          grncode, 
          trsts, 
          pocode 
        } 
      });
    } else if (origin === GRN_VIEW_DETAIL.ORIGIN_INITIATOR) {
      navigate(GRN_ROUTES.LIST); 
    }else if (origin === GRN_VIEW_DETAIL.ORIGIN_VIEW_HISTORY) {
      navigate(GRN_ROUTES.VIEW_HISTORY);
    } else if (origin === GRN_VIEW_DETAIL.ORIGIN_RETURN) {
      navigate(GRN_ROUTES.RETURN_GRN);
    } else if (origin === GRN_VIEW_DETAIL.ORIGIN_GOODS_RETURN_HISTORY) {
      navigate(GRN_ROUTES.GOODS_RETURN_HISTORY);
    } else {
      navigate(RELATED_ROUTES.HOME);
    }
  };

const ACTION_BUTTONS: Record<string, { status: string | number; title: string }> = {
  [GRN_VIEW_DETAIL_REASON_CATEGORY.APPROVE]: {
    status: GRN_STATUS.APPROVE,
    title: BUTTON_LABELS.APPROVE,
  },
  [GRN_VIEW_DETAIL_REASON_CATEGORY.REJECT]: {
    status: GRN_STATUS.REVOKE,
    title: BUTTON_LABELS.REJECT,
  },
  [GRN_VIEW_DETAIL_REASON_CATEGORY.RETURN]: {
    status: GRN_STATUS.REVERSE,
    title: BUTTON_LABELS.RETURN,
  },
  [GRN_VIEW_DETAIL_REASON_CATEGORY.GOODS_RETURN_APPROVE]: {
    status: GRN_GOODS_RETURN_STATUS.APPROVE,
    title: GRN_VIEW_DETAIL_LABELS.GOODS_RETURN_APPROVE,
  },
  [GRN_VIEW_DETAIL_REASON_CATEGORY.GOODS_RETURN_REJECT]: {
    status: GRN_GOODS_RETURN_STATUS.REJECT,
    title: GRN_VIEW_DETAIL_LABELS.GOODS_RETURN_REJECT,
  },
  [GRN_VIEW_DETAIL_REASON_CATEGORY.GOODS_RETURN_RETURN]: {
    status: GRN_GOODS_RETURN_STATUS.RETURN,
    title: GRN_VIEW_DETAIL_LABELS.GOODS_RETURN_RETURN,
  },
};

// Use the actual value of reasonCode, not the setter

console.log("processResponse", processResponse);
const selectedAction = React.useMemo(() => {
  const baseAction = ACTION_BUTTONS[selectedReasonCatCode];
  if (!baseAction) return null;

  // Special case: Approve button (key = "1") + statusCode = 3 → use status = 7
  if (
    selectedReasonCatCode === GRN_VIEW_DETAIL_REASON_CATEGORY.APPROVE &&
    String(statusCode) === GRN_STATUS.HOLD
  ) {
    return { ...baseAction, status: GRN_VIEW_DETAIL.OVERRIDE_APPROVE_STATUS };
  }

  if (
    selectedReasonCatCode === GRN_VIEW_DETAIL_REASON_CATEGORY.REJECT &&
    String(statusCode) === GRN_STATUS.HOLD
  ) {
    return { ...baseAction, status: GRN_VIEW_DETAIL.OVERRIDE_REJECT_STATUS };
  }

  return baseAction;
}, [selectedReasonCatCode, statusCode]);


  useEffect(() => {
    if (grncode &&  trsts) {
      fetchGrnData(grncode,  trsts);
    } else {
      // console.warn("Missing grncode or  trsts in viewData");
      // setAlertType("error");
      // setAlertMessage("Missing GRN code or status");
      // setAlertOpen(true);
    }
  }, [grncode,  trsts]);

  console.log("statusCode", statusCode);
  console.log(" trsts",  trsts);
  console.log("attachmentsxx", attachments);

  // Cleanup persisted data when component unmounts or when user navigates away
  useEffect(() => {
    return () => {
      // Only clear if we're navigating to a completely different section (not edit or view pages)
      const currentPath = window.location.pathname;
      const persistPaths = [
        GRN_ROUTES.EDIT,
        GRN_ROUTES.VIEW_DETAIL,
        GRN_ROUTES.VIEW_APPROVER,
        GRN_ROUTES.CREATE,
      ];
      const shouldClear = !persistPaths.some((path) => currentPath.includes(path));
      if (shouldClear) {
        localStorage.removeItem(GRN_STORAGE_KEYS.GRN_VIEW_DATA);
      }
    };
  }, []);

const handleSubmit = (trsts: string | number): void => {
   if (!reason && holdLikeStatuses.includes(String(statusCode)) ) {
    setReasonError(GRN_ERROR_MESSAGES.REASON_REQUIRED);
    return;
  }
  // Clear any previous error
  setReasonError("");
 const storedCalSummary =
   JSON.parse(localStorage.getItem(GRN_STORAGE_KEYS.NEXT_PROCESS_RESPONSE) || "[]") ||
   [];
    console.log("Stored Cal Summary:", storedCalSummary);
    
  submitGrnData({
    grnItems,
    attachments,
    resattachments,
    grnDetailsForm,
    selectedSupplier,
    USERNAME,
    COMPCODE,
    STAFFMAPLOCODE,
    grncode,
    grnTaxTypes,
    taxValues,
    totalDiscount,
    grnData,
    remark,
    reason,
  trsts: String(trsts),
  sts: CON_STATUS_ZERO,
 addedCharges,
 calSummary: processResponse,

    onSuccess: (response) => {
      // When creating a new GRN (origin === "CreateGrn"), show CREATE_SUCCESS unless it's a hold
      // This handleSubmit function is called when origin === "CreateGrn" or in some edit scenarios
      const isHold = holdLikeStatuses.includes(String(trsts));
      let successMessage: string;

      if (isHold) {
        successMessage = GRN_SUCCESS_MESSAGES.HOLD_SUCCESS;
      } else {
        // If grncode exists, this is an update/edit scenario, show UPDATE_SUCCESS
        // Otherwise, it's a new GRN creation
        successMessage = grncode ? GRN_SUCCESS_MESSAGES.UPDATE_SUCCESS : GRN_SUCCESS_MESSAGES.CREATE_SUCCESS;
      }
      
      console.log("Submit Response:", response);
      console.log("Origin:", origin, "trsts:", trsts, "isHold:", isHold, "Success Message:", successMessage);
      showAlert(successMessage, GRN_ALERT_TYPE.SUCCESS);
      localStorage.removeItem(GRN_STORAGE_KEYS.GRN_PAGE_DATA);
      localStorage.removeItem(GRN_STORAGE_KEYS.GRN_VIEW_DATA); // Clear persisted view data

      setTimeout(() => {
        navigate(GRN_ROUTES.LIST);
      }, GRN_CONSTRAINTS.NAVIGATION_TIMEOUT);
    },
    onError: (error) => {
      const isHold = String(trsts) === GRN_STATUS.HOLD;
      const errorMessage = isHold ? GRN_FAILURE_MESSAGES.HOLD_FAILED : GRN_FAILURE_MESSAGES.CREATE_FAILED;
      console.error("Submit Error:", error);  
      showAlert(errorMessage, GRN_ALERT_TYPE.ERROR);
    },
  });
};


  const fetchGrnData = async (grncode: string,  trsts: string | number): Promise<void> => {
    try {
      const result = await externalgetApi(GRN_API_01, "GET", {
        COMPCODE,
        GRNCODE: grncode,
        STS:  trsts,
      });
    
      setGrnList(result || []);
      setTrackingDetails(result?.[0]?.tracking || []);
      const apiReturnList = result?.[0]?.returnList || [];
      const apiReturns = result?.[0]?.returns || [];
      setGrnReturns(apiReturnList.length > 0 ? apiReturnList : apiReturns);
      setGrnDocuments(result?.[0]?.documents || []);
      setGrPaySummery(result?.[0]?.grnPaySummery || []);
      setGrnPayTax(result?.[0]?.grnPayTax || []);
      setGrnCompany(result?.[0]?.company || []);
      setgrnReturnList(apiReturnList);
      setGrnReturnMaster(result?.[0]?.grnReturnMaster || []);
      setGrnRejectList(result?.[0]?.rejectList || []);
     setotherchargevalue(result?.[0]?.charges || []);
      console.log("result dddd", result);
    } catch (err) {
      console.error("Error fetching GRN data:", err);
      showAlert(GRN_FAILURE_MESSAGES.OPERATION_FAILED, GRN_ALERT_TYPE.ERROR);
    }
  };

  // Map API data to include rejectItem, focItems, and itemAttachments structure
  // This ensures data from API has the same structure as data from location.state
  const mappedProductsFromApi = React.useMemo(() => {
    if (grnList.length > 0 && Array.isArray(grnList[0].products) && grnList[0].products.length > 0) {
      const products = grnList[0].products || [];
      const returns =
        (Array.isArray(grnRejectList) && grnRejectList.length > 0
          ? grnRejectList
          : grnReturns) || [];
      
      return products.map((product) => {
        // Find matching reject item from returns array
        const returnItem = returns.find(
          (ret) => 
            ret.supproductcode === product.supproductcode ||
            String(ret.supproductcode) === String(product.supproductcode) ||
            ret.productcode === product.productcode ||
            String(ret.productcode) === String(product.productcode)
        );

        // Parse reject item attachments from docpathjson
        let rejectAttachments = [];
        if (returnItem?.docpathjson) {
          try {
            const parsed = JSON.parse(returnItem.docpathjson);
            const parsedArray = Array.isArray(parsed) ? parsed : [];
            rejectAttachments = parsedArray
              .filter((att) => {
                const hasValidFileData = 
                  (att?.FILEPATH && att.FILEPATH.trim() !== "") ||
                  (att?.fileUrl && att.fileUrl.trim() !== "") ||
                  (att?.docpathjson && att.docpathjson.trim() !== "") ||
                  (att?.bytarr && att.bytarr.trim && att.bytarr.trim() !== "");
                const hasFileName = att?.FILENAME || att?.filename;
                return hasValidFileData || hasFileName;
              })
              .map((att) => ({
                ...att,
                id: att.id || `${Date.now()}-${Math.random()}`,
              }));
          } catch (err) {
            console.error("Invalid JSON in returnItem.docpathjson:", err);
            rejectAttachments = [];
          }
        }

        // Parse item attachments from product docpathjson
        let itemAttachmentsArray = [];
        if (product?.docpathjson) {
          try {
            const parsed = JSON.parse(product.docpathjson);
            itemAttachmentsArray = Array.isArray(parsed)
              ? parsed.map((att) => ({
                  ...att,
                  id: att.id || `${Date.now()}-${Math.random()}`,
                }))
              : [];
          } catch (err) {
            console.error("Invalid JSON in product.docpathjson:", err);
            itemAttachmentsArray = [];
          }
        }

        return {
          ...product,
          isAdded: product.isAdded !== false, // Default to true if not specified
          rejectItem: returnItem
            ? {
                ...returnItem,
                // Ensure reason and descrip are preserved
                reason:
                  returnItem.reason || returnItem.REASON || GRN_DEFAULTS.STRING,
                descrip:
                  returnItem.descrip || returnItem.DESCRIP || GRN_DEFAULTS.STRING,
                returnedqty:
                  returnItem.returnedqty ||
                  returnItem.returnedQty ||
                  GRN_DEFAULTS.STRING,
                attachments: rejectAttachments,
              }
            : product.rejectItem || {
                returnedqty: GRN_DEFAULTS.STRING,
                reason: GRN_DEFAULTS.STRING,
                descrip: GRN_DEFAULTS.STRING,
                supproductcode: GRN_DEFAULTS.NUMBER,
                productcode: GRN_DEFAULTS.NUMBER,
                attachments: [],
              },
          // Preserve existing itemAttachments or create from parsed data
          itemAttachments: product.itemAttachments || {
            attachments: itemAttachmentsArray,
          },
          // Preserve existing focItems if any
          focItems: product.focItems || [],
        };
      });
    }
    return [];
  }, [grnList, grnReturns, grnRejectList]);

  // Filter grnReturns to only include the latest return per product
  const latestReturnsOnly = React.useMemo(() => {
    // Prefer explicit grnReturns; if absent, fall back to grnRejectList so the Rejection Note has rows.
    const sourceReturns =
      grnReturns && grnReturns.length > 0 ? grnReturns : grnRejectList || [];
    if (!sourceReturns || sourceReturns.length === 0) return [];

    // Group returns by supproductcode and productcode
    const returnsByProduct = new Map<string, AnyForNow[]>();
    
    sourceReturns.forEach((ret) => {
      const key = `${ret.supproductcode || ret.productcode}`;
      if (!returnsByProduct.has(key)) {
        returnsByProduct.set(key, []);
      }
      returnsByProduct.get(key)!.push(ret);
    });

    // Get the latest return for each product
    const latestReturns: AnyForNow[] = [];
    returnsByProduct.forEach((returns) => {
      // Sort by grnreturncode or grnreturndetcode descending (higher = newer)
      const sorted = returns.sort((a, b) => {
        const codeA = parseInt(
          a.grnreturncode || a.grnreturndetcode || GRN_DEFAULTS.NUMBER
        );
        const codeB = parseInt(
          b.grnreturncode || b.grnreturndetcode || GRN_DEFAULTS.NUMBER
        );
        return codeB - codeA;
      });
      latestReturns.push(sorted[0]);
    });

    return latestReturns;
  }, [grnReturns, grnRejectList]);

  // Prefer the in-memory items (coming from Create/Edit screens) so that
  // unsaved edits are not overwritten when the async GRN API response arrives.
  // Also use persisted data if available and API data is empty
  const baseProducts =
    Array.isArray(grnItems) && grnItems.length > 0
      ? grnItems
      : mappedProductsFromApi.length > 0
      ? mappedProductsFromApi
      : viewData.grnItems && Array.isArray(viewData.grnItems) && viewData.grnItems.length > 0
      ? viewData.grnItems
      : [];

// If we have processed calculation data (dtCalProducts), overlay tax/gross values so item-level
// display matches the backend-calculated amounts (e.g., bill-level discounts).
const processedResponse = Array.isArray(processResponse)
  ? processResponse[0]
  : processResponse;
const calProducts = processedResponse?.dtCalProducts || [];

const productsToDisplay =
  Array.isArray(calProducts) && calProducts.length > 0
    ? baseProducts.map((item: AnyForNow) => {
        const calculated = calProducts.find(
          (p: AnyForNow) => String(p.supproductcode) === String(item.supproductcode)
        );
        if (!calculated) return item;

        const calculatedTax = Number(calculated.taxvalue);
        const hasCalculatedTax = !Number.isNaN(calculatedTax);

        return {
          ...item,
          grossvalue: calculated.grossvalue ?? item.grossvalue,
          itemvalue: calculated.grossvalue ?? item.itemvalue ?? item.grossvalue,
          taxvalue: hasCalculatedTax ? calculatedTax : item.taxvalue,
          taxableamount: calculated.taxableamount ?? item.taxableamount,
          perunittaxvalue: calculated.perunittaxvalue ?? item.perunittaxvalue,
        };
      })
    : baseProducts;
console.log("productsToDisplay:", productsToDisplay);


const handleActionSubmit = async (trsts: string | number): Promise<void> => {
  if (!reason && holdLikeStatuses.includes(String(statusCode)) ) {
    setReasonError(GRN_ERROR_MESSAGES.REASON_REQUIRED);
    return;
  }
  // Clear any previous error
  setReasonError("");

const payload = {
  grnBulkStsDet: [
    {
      grncode: grncode || GRN_DEFAULTS.STRING,
      descrip: remark || GRN_DEFAULTS.STRING,
      reason: reason || GRN_DEFAULTS.STRING,
      enuser: USERNAME || GRN_DEFAULTS.STRING,
      documents: GRN_DEFAULTS.STRING,
grnreturncode:"",
      trsts: String(trsts) || GRN_DEFAULTS.STRING,
      sts: String(trsts),
      // sts: statusCode === "4" ? "0" : "1", // If current status is 4 (Return), set to 1 (Approved) on action
      dtoReasonDOCs:
        resattachments && resattachments.length > 0
          ? resattachments.map((att) => ({
              doctypecode: att.doctypecode || GRN_DEFAULTS.STRING,
              doctypeothername: att.doctypeothername || GRN_DEFAULTS.STRING,
              docpathjson: att.docpathjson || GRN_DEFAULTS.STRING, // always empty string
              filename: att.docpathjson || GRN_DEFAULTS.STRING,
              bytarr: att.docpathjson || GRN_DEFAULTS.STRING,
                remark: att.docremark || GRN_DEFAULTS.STRING,
            }))
          : [
              {
                doctypecode: GRN_DEFAULTS.STRING,
                doctypeothername: GRN_DEFAULTS.STRING,
                docpathjson: GRN_DEFAULTS.STRING,
                filename: GRN_DEFAULTS.STRING,
                bytarr: GRN_DEFAULTS.STRING,
                remark: GRN_DEFAULTS.STRING,
              },
            ],
    },
  ],
  compcode: COMPCODE || GRN_DEFAULTS.STRING,
  businesstypecode: CON_BUSINESS_TYPECODE,
};

  // ...rest of your function...
console.log("Action Payload:", payload);

  const statusMessages = {
      [GRN_STATUS.APPROVE]: GRN_SUCCESS_MESSAGES.APPROVE_SUCCESS,
      [GRN_STATUS.REVOKE]: GRN_SUCCESS_MESSAGES.REJECT_SUCCESS,
      [GRN_STATUS.REVERSE]: GRN_SUCCESS_MESSAGES.RETURN_SUCCESS,
      [GRN_STATUS.HOLD]: GRN_SUCCESS_MESSAGES.HOLD_SUCCESS,
    };
    try {
      const response = await externalpostApi(GRN_API_11, payload);
      // When coming from EditGrn and confirming, show UPDATE_SUCCESS
      // Status changes (approve/reject/return) should show their specific messages
      const isStatusChange = String(trsts) === GRN_STATUS.APPROVE ||
                            String(trsts) === GRN_STATUS.REVOKE ||
                            String(trsts) === GRN_STATUS.REVERSE ||
                            String(trsts) === GRN_STATUS.HOLD;
      
      let successMessage: string;
      if (statusMessages[trsts]) {
        // Use specific message for status changes (approve/reject/return)
        successMessage = statusMessages[trsts];
      } else if (origin === GRN_VIEW_DETAIL.ORIGIN_EDIT && !isStatusChange) {
        // When coming from EditGrn and confirming creation/submission, show UPDATE_SUCCESS
        successMessage = GRN_SUCCESS_MESSAGES.UPDATE_SUCCESS;
      } else {
        // Default to UPDATE_SUCCESS for other cases
        successMessage = GRN_SUCCESS_MESSAGES.UPDATE_SUCCESS;
      }
      
      console.log("handleActionSubmit - Origin:", origin, "trsts:", trsts, "isStatusChange:", isStatusChange, "Success Message:", successMessage);
      showAlert(successMessage, GRN_ALERT_TYPE.SUCCESS);
      localStorage.removeItem(GRN_STORAGE_KEYS.GRN_VIEW_DATA); // Clear persisted view data
    setTimeout(() => {
  if (returnApprovalStatuses.includes(String(statusCode))) {
    navigate(GRN_ROUTES.VIEW_HOOD_RETURN_APPROVAL);
  } else if (origin === GRN_VIEW_DETAIL.ORIGIN_EDIT) {
    navigate(GRN_ROUTES.LIST);
  } else
     {
    navigate(GRN_ROUTES.VIEW_APPROVER);
  }
}, GRN_CONSTRAINTS.NAVIGATION_TIMEOUT);
    } catch (error) {
      console.error("Error submitting approval:", error);
      showAlert(GRN_FAILURE_MESSAGES.OPERATION_FAILED, GRN_ALERT_TYPE.ERROR);
    }
  };

  return (
    <>
      <Box
        sx={{
          mx: "auto",
          p: 2,
          background: theme.palette.background.paper,
        }}
      >
        <ViewDetailGrnBody
            grnItems={productsToDisplay}
            selectedSupplier={selectedSupplier}
            grnDetailsForm={grnDetailsForm}
            attachments={attachments}
            statusCode={statusCode}
            grnHeader={grnList.length > 0 ? grnList[0].header : null}
            grncode={grncode}
            trackingDetails={trackingDetails}
             trsts={ trsts}
            grnDocuments={grnDocuments}
            grnReturns={latestReturnsOnly}
            grnRejectList={grnRejectList}
            grnPaySummery={grnPaySummery}
            grnPayTax={grnPayTax}
            grnData={grnData}
            totalGross={totalGross}
            taxValues={taxValues}
            grnTaxTypes={grnTaxTypes}
            grnCompany={grnCompany}
            origin={origin}
           grncharges={grncharges}
           addedCharges={addedCharges}
            grnReturnList={grnReturnList}
            grnReturnMaster={grnReturnMaster}
            otherchargevalue={otherchargevalue}
        processResponse={processResponse}
        grncal={grncal}
        calSummary={calSummary}

          />

{origin === GRN_VIEW_DETAIL.ORIGIN_CREATE && (
  <>
    <ReviewGrnAction
     origin={origin}
      statusCode={statusCode}
      grncode={grncode}
      remark={remark}
      setRemark={setRemark}
      reason={reason}
      setReason={setReason}
      reasonCode={reasonCode}
      selectedReasonCatCode={selectedReasonCatCode}     // pass down
  setSelectedReasonCatCode={setSelectedReasonCatCode} // pass down    // <-- NEW: pass selected reason code
  setReasonCode={setReasonCode} // <-- NEW: updater for reason code
      actionType={statusCode} // Pass the status code number
      reasonError={reasonError}
      setReasonError={setReasonError}
    />
   <Box sx={{ width: "48%", mb: 6,  }}>
        <Grnresattachments
          attachments={resattachments}
          setAttachments={setresAttachments}
        />
      </Box>
  </>
)}

{origin === GRN_VIEW_DETAIL.ORIGIN_EDIT && (
  <>
    <ReviewGrnAction
     origin={origin}
      statusCode={statusCode}
      grncode={grncode}
      remark={remark}
      setRemark={setRemark}
      reason={reason}
      setReason={setReason}
      reasonCode={reasonCode}
      selectedReasonCatCode={selectedReasonCatCode}     // pass down
  setSelectedReasonCatCode={setSelectedReasonCatCode} // pass down    // <-- NEW: pass selected reason code
  setReasonCode={setReasonCode} // <-- NEW: updater for reason code
      actionType={statusCode} // Pass the status code number
      reasonError={reasonError}
      setReasonError={setReasonError}
    />
   <Box sx={{width: "48%", mb: 6 }}>
        <Grnresattachments
          attachments={resattachments}
          setAttachments={setresAttachments}
        />
      </Box>
  </>
)}

{origin === GRN_VIEW_DETAIL.ORIGIN_APPROVER &&
  !approverHiddenStatuses.includes(normalizedStatusCode) && (
  <>
    <ReviewGrnAction
      origin={origin}
      statusCode={statusCode}
      grncode={grncode}
      remark={remark}
      setRemark={setRemark}
      reason={reason}
      setReason={setReason}
      selectedReasonCatCode={selectedReasonCatCode}
      setSelectedReasonCatCode={setSelectedReasonCatCode}
      reasonCode={reasonCode}
      setReasonCode={setReasonCode}
      actionType={statusCode}
      reasonError={reasonError}
      setReasonError={setReasonError}
    />
    <Box sx={{ width: "48%", mb: 6 }}>
      <Grnresattachments
        attachments={resattachments}
        setAttachments={setresAttachments}
      />
    </Box>
  </>
)}


{/* 
  <Box sx={{ width: "40%", mb: 6 }}>
        <Grnresattachments
          attachments={resattachments}
          setAttachments={setresAttachments}
        />
      </Box> */}


        <Divider />

        <Box
          my={2}
          pb={2}
          gap={2}
          width={"100%"}
          display={"flex"}
          justifyContent={"flex-end"}
        >
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            sx={{ ...styles.btn_secondary }}
            onClick={goToBack}
          >
            {BUTTON_LABELS.BACK}
          </Button>

{origin === GRN_VIEW_DETAIL.ORIGIN_CREATE && (
  
<Button
  variant="contained"
  color="primary"
  size="medium"
  sx={{ ...styles.btn_primary }}
onClick={() => {
  if (holdLikeStatuses.includes(String(statusCode))) {
    setConfirmHoldOpen(true);
    return;
  }
  handleSubmit(trsts);
}}


  
>
  {BUTTON_LABELS.CONFIRM}
</Button>


)}




       {origin === GRN_VIEW_DETAIL.ORIGIN_EDIT && (
  <Button
    variant="contained"
    color="primary"
    size="medium"
    sx={{ ...styles.btn_primary }}
      onClick={() => {
  if (holdLikeStatuses.includes(String(statusCode))) {
    setConfirmHoldOpen(true);
    return;
  }
handleActionSubmit(trsts);
}}
  >
    {BUTTON_LABELS.CONFIRM}
  </Button>
)}


          {/* {origin === "ViewApprover" && (
            <Button
              variant="contained"
              color="primary"
              size="medium"
              sx={{ ...styles.btn_primary }}
              onClick={() => handleActionSubmit(CON_GRN_STATUS_REVERSE)}
            >
              Return
            </Button>
          )}
          {origin === "ViewApprover" && (
            <Button
              variant="contained"
              color="primary"
              size="medium"
              sx={{ ...styles.btn_primary }}
              onClick={() => handleActionSubmit(CON_GRN_STATUS_REVOKE)}
            >
              Reject
            </Button>
          )}
          {origin === "ViewApprover" && (
            <Button
              variant="contained"
              color="primary"
              size="medium"
              sx={{ ...styles.btn_primary }}
              // onClick={handleActionSubmit}
              onClick={() => handleActionSubmit(CON_GRN_STATUS_APPROVE)}
            >
              Approve
            </Button>
          )} */}
{origin === GRN_VIEW_DETAIL.ORIGIN_APPROVER &&
  !approverHiddenStatuses.includes(normalizedStatusCode) && (
<Button
  variant="contained"
  color="primary"
  size="medium"
  sx={{ ...styles.btn_primary }}
  disabled={!selectedAction?.status}
  onClick={() => handleActionSubmit(selectedAction.status)}
>
  {BUTTON_LABELS.CONFIRM}
</Button>

)}


        </Box>
      </Box>
      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        // onClose={() => setAlertOpen(false)}
        // type="error"
        onClose={handleAlertClose}
      />

     <PopUp
  open={confirmHoldOpen}
  handleClose={() => setConfirmHoldOpen(false)}
  title={GRN_CONFIRM_MESSAGES.HOLD_GRN}
  content={
    <Typography variant="body1">
      {GRN_CONFIRM_MESSAGES.HOLD_GRN_WARNING}
    </Typography>
  }
  actions={
    <>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => setConfirmHoldOpen(false)}
      >
        {BUTTON_LABELS.NO}
      </Button>
     <Button
  variant="contained"
  color="primary"
  onClick={() => {
    setConfirmHoldOpen(false);

    if (origin === GRN_VIEW_DETAIL.ORIGIN_EDIT) {
      // Inside EditGrn mode
     handleActionSubmit(String(trsts)); // condition true
    } else {
      // Default non-EditGrn flow
      handleSubmit(String(trsts)); // condition false
    }
  }}
>
  {BUTTON_LABELS.YES}
</Button>

    </>
  }
/>

    </>
  );
};

export default ViewGrnHistory;
